"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Translator = exports.TranslateProvider = exports.TarnslationsContext = void 0;
exports.gettext = gettext;
exports.interpolate = interpolate;
exports.isRtlLanguage = isRtlLanguage;
exports.ngettext = ngettext;
exports.npgettext = npgettext;
exports.pgettext = pgettext;
exports.useGetLanguage = useGetLanguage;
exports.useGettext = useGettext;
exports.useNGettext = useNGettext;
exports.useNPGettext = useNPGettext;
exports.usePGettext = usePGettext;
exports.useSetLanguage = useSetLanguage;
exports.useTranslations = useTranslations;
var _react = require("react");
var _fastPluralRules = require("fast-plural-rules");
var _get = _interopRequireDefault(require("lodash/get"));
var _noop = _interopRequireDefault(require("lodash/noop"));
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["translations"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var TarnslationsContext = (0, _react.createContext)({});
exports.TarnslationsContext = TarnslationsContext;
function isRtlLanguage(lang) {
  var rtlLanguages = ['ar', 'arc', 'dv', 'fa', 'ha', 'he', 'khw', 'ks', 'ku', 'ps', 'ur', 'yi'];
  if (!lang) {
    return false;
  }
  return rtlLanguages.includes(lang.split('-')[0]);
}
var defaultProps = {
  defaultLanguage: 'en',
  langKey: 'lang',
  translationsKey: 'translations',
  reload: _noop.default,
  monoLanguageJSON: false
};
var TranslateProvider = function (_Component) {
  _inherits(TranslateProvider, _Component);
  var _super = _createSuper(TranslateProvider);
  function TranslateProvider(props) {
    var _this;
    _classCallCheck(this, TranslateProvider);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "langs", void 0);
    _defineProperty(_assertThisInitialized(_this), "lang", void 0);
    _this.langs = [];
    _this.state = {
      translations: props.defaultTranslations || {},
      language: props.defaultLanguage.split('-')[0]
    };
    _this.gettext = _this.gettext.bind(_assertThisInitialized(_this));
    _this.pgettext = _this.pgettext.bind(_assertThisInitialized(_this));
    _this.setLanguage = _this.setLanguage.bind(_assertThisInitialized(_this));
    _this.ngettext = _this.ngettext.bind(_assertThisInitialized(_this));
    _this.npgettext = _this.npgettext.bind(_assertThisInitialized(_this));
    _this.refreshTranslations = _this.refreshTranslations.bind(_assertThisInitialized(_this));
    _this.initTranslationsLang();
    return _this;
  }
  _createClass(TranslateProvider, [{
    key: "refreshTranslations",
    value: function refreshTranslations(lang) {
      var _this2 = this;
      var _this$props = this.props,
        getTranslation = _this$props.getTranslation,
        translationsKey = _this$props.translationsKey,
        storage = _this$props.storage;
      Promise.resolve(getTranslation(lang)).then(function (translations) {
        _this2.setState({
          translations: translations
        });
        storage && translationsKey && translations && storage.setItem([translationsKey, lang].filter(Boolean).join('_'), JSON.stringify(translations));
      }).catch(_noop.default);
    }
  }, {
    key: "initTranslations",
    value: function initTranslations(lang) {
      var _this3 = this;
      var _this$props2 = this.props,
        storage = _this$props2.storage,
        translationsKey = _this$props2.translationsKey;
      if (!storage || !translationsKey) return;
      Promise.resolve(storage.getItem([translationsKey, lang].filter(Boolean).join('_'))).then(function (translations) {
        if (!translations) {
          return;
        }
        _this3.setState({
          translations: JSON.parse(translations)
        });
      });
    }
  }, {
    key: "saveLang",
    value: function saveLang(lang) {
      this.lang = this.langs.find(function (item) {
        return typeof item === 'string' ? item === lang : item.id = lang;
      });
    }
  }, {
    key: "getLanguage",
    value: function getLanguage(lang, defaultLang, langs) {
      if (!Array.isArray(langs)) {
        return lang;
      }
      if (langs.find(function (item) {
        return typeof item === 'string' ? item === lang : item.id = lang;
      })) {
        return lang;
      }
      return defaultLang;
    }
  }, {
    key: "initTranslationsLang",
    value: function initTranslationsLang() {
      var _this4 = this;
      if (this.props.useDefaultLanguage) return this.refreshTranslations(this.props.defaultLanguage);
      var _this$props3 = this.props,
        storage = _this$props3.storage,
        langKey = _this$props3.langKey,
        defaultLanguage = _this$props3.defaultLanguage;
      Promise.all([Promise.resolve(storage.getItem(langKey)), this.props.getLanguages ? Promise.resolve(this.props.getLanguages()) : null]).then(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
          language = _ref2[0],
          langs = _ref2[1];
        _this4.langs = langs;
        if (!language) {
          return Promise.reject(langs);
        }
        var _lang = _this4.getLanguage(language, _this4.props.defaultLanguage, langs);
        _this4.saveLang(_lang);
        _this4.setState({
          language: _lang
        });
        _this4.refreshTranslations(_lang);
        _this4.initTranslations(_lang);
      }).catch(function (langs) {
        var _lang = _this4.getLanguage(_this4.props.localeLanguage, _this4.props.defaultLanguage, langs);
        _this4.saveLang(_lang);
        storage.setItem(langKey, _lang.split('-')[0]);
        _this4.refreshTranslations(_lang.split('-')[0]);
        _this4.initTranslations(_lang.split('-')[0]);
      });
    }
  }, {
    key: "setLanguage",
    value: function setLanguage(lang) {
      var _this5 = this;
      if (this.props.useDefaultLanguage) return;
      if (!lang) {
        throw new Error('language should be defined');
      }
      if (typeof lang !== 'string') {
        throw new Error('language should be String');
      }
      this.saveLang(lang);
      var language = this.state.language;
      var _this$props4 = this.props,
        storage = _this$props4.storage,
        langKey = _this$props4.langKey;
      this.setState({
        language: lang
      });
      this.refreshTranslations(lang);
      Promise.resolve(storage.setItem(langKey, lang.split('-')[0])).then(function () {
        if (isRtlLanguage(language) !== isRtlLanguage(lang)) {
          _this5.props.reload && _this5.props.reload();
        }
      });
    }
  }, {
    key: "pgettext",
    value: function pgettext(text, id, params) {
      var message = "".concat(text, " ").concat(id);
      var monoLanguageJSON = this.props.monoLanguageJSON;
      var _this$state = this.state,
        language = _this$state.language,
        translations = _this$state.translations;
      if (monoLanguageJSON) {
        return interpolate((0, _get.default)(translations, "[".concat(id, "]")) || text, text, params);
      }
      return interpolate((0, _get.default)(translations, "".concat(language, ".[").concat(id, "]")) || text, text, params);
    }
  }, {
    key: "gettext",
    value: function gettext() {
      var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var params = arguments.length > 1 ? arguments[1] : undefined;
      var _this$state2 = this.state,
        language = _this$state2.language,
        translations = _this$state2.translations;
      var monoLanguageJSON = this.props.monoLanguageJSON;
      if (monoLanguageJSON) {
        return interpolate((0, _get.default)(translations, "[".concat(text, "]")) || text || '', text, params);
      }
      return interpolate((0, _get.default)(translations, "".concat(language, "[").concat(text, "]")) || text, text, params);
    }
  }, {
    key: "ngettext",
    value: function ngettext(singular, plural, count, params) {
      var _this$state3 = this.state,
        language = _this$state3.language,
        translations = _this$state3.translations;
      var monoLanguageJSON = this.props.monoLanguageJSON;
      var _tranlations = monoLanguageJSON ? translations : (0, _get.default)(translations, language);
      var pluralForm = (0, _fastPluralRules.getPluralFormNameForCardinalByLocale)(language, count);
      var key = [singular, pluralForm].join('_');
      return interpolate((0, _get.default)(_tranlations, key) || (count === 1 ? singular : plural) || '', count === 1 ? singular : plural, params);
    }
  }, {
    key: "npgettext",
    value: function npgettext(singular, plural, id, count, params) {
      var _this$state4 = this.state,
        language = _this$state4.language,
        translations = _this$state4.translations;
      var monoLanguageJSON = this.props.monoLanguageJSON;
      var _tranlations = monoLanguageJSON ? translations : (0, _get.default)(translations, language);
      var pluralForm = (0, _fastPluralRules.getPluralFormNameForCardinalByLocale)(language, count);
      var key = [id, pluralForm].join('_');
      return interpolate((0, _get.default)(_tranlations, key) || (count === 1 ? singular : plural) || '', count === 1 ? singular : plural, params);
    }
  }, {
    key: "render",
    value: function render() {
      return (0, _jsxRuntime.jsx)(TarnslationsContext.Provider, {
        value: {
          translations: this.state.translations,
          gettext: this.gettext,
          pgettext: this.pgettext,
          ngettext: this.ngettext,
          npgettext: this.npgettext,
          setLanguage: this.setLanguage,
          language: this.state.language
        },
        children: this.props.children
      });
    }
  }]);
  return TranslateProvider;
}(_react.Component);
exports.TranslateProvider = TranslateProvider;
TranslateProvider.defaultProps = defaultProps;
function useTranslations() {
  var _useContext = (0, _react.useContext)(TarnslationsContext),
    _ = _useContext.translations,
    translationData = _objectWithoutProperties(_useContext, _excluded);
  return translationData;
}
function useGetLanguage() {
  return (0, _react.useContext)(TarnslationsContext).language;
}
function useGettext() {
  return {
    gettext: (0, _react.useContext)(TarnslationsContext).gettext
  };
}
function usePGettext() {
  return {
    pgettext: (0, _react.useContext)(TarnslationsContext).pgettext
  };
}
function useNGettext() {
  return {
    ngettext: (0, _react.useContext)(TarnslationsContext).ngettext
  };
}
function useNPGettext() {
  return {
    npgettext: (0, _react.useContext)(TarnslationsContext).npgettext
  };
}
function useSetLanguage() {
  return (0, _react.useContext)(TarnslationsContext).setLanguage;
}
var Translator = TarnslationsContext.Consumer;
exports.Translator = Translator;
function gettext() {
  var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var params = arguments.length > 1 ? arguments[1] : undefined;
  return (0, _jsxRuntime.jsx)(TarnslationsContext.Consumer, {
    children: function children(_ref3) {
      var gettext = _ref3.gettext;
      return gettext(text, params);
    }
  });
}
function pgettext() {
  var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var text = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var params = arguments.length > 2 ? arguments[2] : undefined;
  return (0, _jsxRuntime.jsx)(TarnslationsContext.Consumer, {
    children: function children(_ref4) {
      var pgettext = _ref4.pgettext;
      return pgettext(id, text, params);
    }
  });
}
function ngettext() {
  var singular = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var plural = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var count = arguments.length > 2 ? arguments[2] : undefined;
  var params = arguments.length > 3 ? arguments[3] : undefined;
  return (0, _jsxRuntime.jsx)(TarnslationsContext.Consumer, {
    children: function children(_ref5) {
      var ngettext = _ref5.ngettext;
      return ngettext(singular, plural, count, params);
    }
  });
}
function npgettext() {
  var singular = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var plural = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var id = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var count = arguments.length > 3 ? arguments[3] : undefined;
  var params = arguments.length > 4 ? arguments[4] : undefined;
  return (0, _jsxRuntime.jsx)(TarnslationsContext.Consumer, {
    children: function children(_ref6) {
      var npgettext = _ref6.npgettext;
      return npgettext(singular, plural, id, count, params);
    }
  });
}
function interpolate(message, defaultLang, obj, named) {
  var msg = message;
  if (typeof message !== 'string') {
    return defaultLang;
  }
  try {
    msg = (message || '').replace(/%\(\w+\)/g, function (match) {
      return String((0, _get.default)(obj, [match.slice(2, -1)]));
    });
  } catch (_unused) {}
  return msg;
}
//# sourceMappingURL=i18n.js.map